import { USER } from "../actions";

const defaultState = {
  current: { loading: false, error: false, id: null, role: null, email: null },
  all: [],
  loading: false,
  error: false
};

const login = state => ({ ...state, current: { ...state.current, loading: true, error: false } });

const loginSuccess = (state, action) => {
  return {
    ...state,
    current: { ...state.current, loading: false, error: false, ...action.payload }
  };
};

const loginError = state => ({
  ...state,
  current: { ...state.current, loading: false, error: true }
});

const fetch = state => ({ ...state, loading: true, error: false });
const fetchSuccess = (state, { payload }) => ({
  ...state,
  all: payload,
  loading: false,
  error: false
});
const fetchError = state => ({ ...state, loading: false, error: true });

const ACTION_HANDLERS = {
  [USER.LOGIN]: login,
  [USER.LOGIN_SUCCESS]: loginSuccess,
  [USER.LOGIN_ERROR]: loginError,
  [USER.FETCH]: fetch,
  [USER.FETCH_SUCCESS]: fetchSuccess,
  [USER.FETCH_ERROR]: fetchError
};

export default (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
